/**
 * Shared admin-page language helpers (System, GeoDataRevision, Elasticsearch, …).
 */

export function readStoredLang (storageKey, fallback = 'de') {
  try {
    const value = localStorage.getItem(storageKey)
    return value === 'en' || value === 'de' ? value : fallback
  } catch {
    return fallback
  }
}

export function writeStoredLang (storageKey, lang) {
  try {
    localStorage.setItem(storageKey, lang)
  } catch {
    // Ignore private-mode / quota errors.
  }
}
